import { render, staticRenderFns } from "./CarteraOdontologia.vue?vue&type=template&id=4df72a19"
import script from "./CarteraOdontologia.vue?vue&type=script&lang=js"
export * from "./CarteraOdontologia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports